import { render, staticRenderFns } from "./LaboTestTab.vue?vue&type=template&id=3e494bf8&scoped=true&"
import script from "./LaboTestTab.vue?vue&type=script&lang=ts&"
export * from "./LaboTestTab.vue?vue&type=script&lang=ts&"
import style0 from "./LaboTestTab.vue?vue&type=style&index=0&id=3e494bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e494bf8",
  null
  
)

export default component.exports